import { CARD_MESSAGES } from 'core/tarjeta/constants/CardMessages';
import { ApiError } from 'shared/http';

export class SearchCardsTotalsError {
  message: string;

  constructor(err: ApiError) {
    switch (err.status) {
      case 400:
        if (err.message === 'no_cards') {
          this.message = CARD_MESSAGES.accountHasNoCards;
        } else {
          this.message = CARD_MESSAGES.accountNotFound;
        }
        break;
      case 403:
        if (err.message === 'invalid_organization') {
          this.message = CARD_MESSAGES.accountNotAllowed;
        } else {
          this.message = CARD_MESSAGES.accountNotAllowedToCostCenter;
        }
        break;
    }
  }
}
